export default __webpack_public_path__ + "static/media/icon-on-robot.a22aee04.svg";